import { render, staticRenderFns } from "./UserDetailsCard.vue?vue&type=template&id=2f73e234&scoped=true"
import script from "./UserDetailsCard.vue?vue&type=script&lang=js"
export * from "./UserDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73e234",
  null
  
)

export default component.exports